module.exports = __webpack_public_path__ + "img/defaultImg.d250de30.png";